import React, { useContext } from 'react';
import { ThemeContext } from '../../hooks/ThemeContext';

const Index = () => {
    const { theme } = useContext(ThemeContext);
    const isDark = theme === 'dark';

    return (
        <div className={`flex-1 flex flex-col ${isDark ? 'bg-[#0f1114] text-white' : 'bg-slate-50 text-gray-800'}`}>
            <div className="container mx-auto px-4 py-12 max-w-7xl">
                <h1 className="text-3xl font-bold mb-4">Mes commandes</h1>
                <p className="text-lg opacity-90">Vous n'avez aucune commande pour le moment.</p>
            </div>
        </div>
    );
};

export default Index;